import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';

interface ScreenSize {
	width: number;
	height: number;
}

const PLAYER_SMALL_SIZE_THRESHOLD = 768;
const PLAYER_ICON_PRIORITY_0_WIDTH = 443;
const PLAYER_ICON_PRIORITY_1_WIDTH = 369;
const PLAYER_ICON_PRIORITY_2_WIDTH = 307;
const PLAYER_ICON_PRIORITY_3_WIDTH = 259;
const PLAYER_ICON_PRIORITY_4_WIDTH = 231;
const PLAYER_ICON_PRIORITY_5_WIDTH = 209;
const PLAYER_ICON_PRIORITY_6_WIDTH = 169;

// Maps range of numbers to priority value denoted by the index
const rangeMap = [
	[Number.MAX_VALUE, PLAYER_ICON_PRIORITY_0_WIDTH],
	[PLAYER_ICON_PRIORITY_0_WIDTH, PLAYER_ICON_PRIORITY_1_WIDTH],
	[PLAYER_ICON_PRIORITY_1_WIDTH, PLAYER_ICON_PRIORITY_2_WIDTH],
	[PLAYER_ICON_PRIORITY_2_WIDTH, PLAYER_ICON_PRIORITY_3_WIDTH],
	[PLAYER_ICON_PRIORITY_3_WIDTH, PLAYER_ICON_PRIORITY_4_WIDTH],
	[PLAYER_ICON_PRIORITY_4_WIDTH, PLAYER_ICON_PRIORITY_5_WIDTH],
	[PLAYER_ICON_PRIORITY_5_WIDTH, PLAYER_ICON_PRIORITY_6_WIDTH],
	[PLAYER_ICON_PRIORITY_6_WIDTH, 0]
];

@Injectable()
export class PlayerSizeDetectionService {
	public screenSizeSubject$ = new BehaviorSubject<ScreenSize>({ width: 0, height: 0 });
	public playerIconPriority$ = this.screenSizeSubject$.asObservable().pipe(map(size => this.getPlayerIconPriority(size.width)));
	public isSmallSizePlayer = false;

	public setPlayerSize(width: number, height: number): void {
		this.screenSizeSubject$.next({ width, height });
		this.isSmallSizePlayer = width < PLAYER_SMALL_SIZE_THRESHOLD && width !== 0;
	}

	private getPlayerIconPriority(playerWidth: number): number {
		if (!playerWidth) {
			return 0;
		}

		let priority = 7;
		rangeMap.forEach((range, index) => {
			if (playerWidth <= range[0] && playerWidth > range[1]) {
				priority = index;
				return;
			}
		});
		return priority;
	}
}
